import { DirtyModel } from "./dirty_model";

import { HasSocketEvent } from "./has_socket_event";
import { SocketEvent } from "@helpers/types";

export abstract class Wallet extends DirtyModel implements HasSocketEvent {
	protected balance: string = "";
	protected name: string = "";
	protected pending_transactions_count: number = 0;
	protected isNewWallet: boolean = false;

	public eventData: SocketEvent = "";
	public static TypeName: string = "Wallet";

	public abstract getCurrencyId(): string;
	public abstract setCurrencyId(id: string): void;
	public abstract isNew(): boolean;
	public abstract setNew(b: boolean): void;
	public abstract getBaseUrl(): string;

	public reduceBalance(amount: number): void {
		this.balance = this.getBalance() - amount + "";
	}

	public addBalance(amount: number | string): void {
		this.balance = this.getBalance() + +amount + "";
	}

	public getName(): string {
		return this.name;
	}

	public setName(s: string): void {
		this.name = s;
	}

	public setBalance(balance: number): void {
		this.balance = balance + "";
	}

	public getBalance(): number {
		return +this.balance;
	}

	public reducePending(): void {
		this.pending_transactions_count = Math.max(this.pending_transactions_count - 1, 0);
	}

	public getPendingTransactionCount(): number {
		return this.pending_transactions_count;
	}

	public getEvent(): string {
		return this.eventData;
	}
}
